///
/// Copyright (c) 2017-present, Siklu Ltd.
/// All rights reserved.
///

import { Component, EventEmitter, Output } from '@angular/core';
import { GtthHistoryService } from '../../logical-topology/engine/history-service';
import { ActionsToolbarModeEnum } from '../../../generated/shared-types.model';
import { GtthHouseDetectionCommand } from '../../logical-topology/engine/commands/node/house-detection-command';
import { GtthNotificationsService } from '../../logical-topology/engine/notifications-service';
import { GtthExportService } from '../../../services/project/export.service';
import { Router } from '@angular/router';
import { GtthLogicalTopology } from '../../logical-topology/entities/logical-topology';

@Component({
    selector: 'winde-step-enter-location',
    templateUrl: './step-enter-location.component.html',
    styleUrls: ['./enter-location.scss', '../steps-toolbar.scss'],
    standalone: false
})
export class GtthStepEnterLocationComponent {
    @Output() stateChanged = new EventEmitter<{ type: number; terminalLayer?: number }>();

    modeType = ActionsToolbarModeEnum;

    terminalMarkersArray = [
        { index: 0, iconName: 'unit__icon--circle-node' },
        { index: 1, iconName: 'unit__icon--square-node' },
        { index: 2, iconName: 'unit__icon--rhombus-node' }
    ];

    constructor(
        public readonly historyService: GtthHistoryService,
        private readonly router: Router,
        private readonly notificationService: GtthNotificationsService,
        private readonly exportService: GtthExportService
    ) {}

    modeChanged(type: ActionsToolbarModeEnum, terminalLayer?: number) {
        const dataObj: { type: number; terminalLayer?: number } = { type };
        if (terminalLayer > GtthLogicalTopology.WHOLE_TOPOLOGY_LAYER_INDEX) {
            dataObj.terminalLayer = terminalLayer;
        }
        this.stateChanged.emit(dataObj);
    }

    downloadTemplate() {
        this.exportService.uploadImportFileTemplate();
    }

    startHouseDetection(event) {
        event.stopPropagation();

        const storedPolygons = this.historyService.polygonsService.getStoredPolygonsPaths();

        const path = this.historyService.selectAreaService.getSelectedAreaPath().map((point) => point.toPositionDto());
        if (path?.length) {
            storedPolygons.push(path);
        }

        if (!storedPolygons || storedPolygons.length === 0) {
            this.notificationService.showError('Please select area on map first');
            return;
        }

        const houseDetectionCommand = this.historyService.command(GtthHouseDetectionCommand).create(storedPolygons);
        this.historyService.doCommand(houseDetectionCommand);
    }

    openImportModal(event) {
        event.stopPropagation();
        const target = this.historyService.logicalTopology.getTerminalStationsCount() === 0 ? 'topology' : 'nodes';
        this.router.navigate(['/', { outlets: { popup: `project-view/import-${target}` } }]);
    }
}
